import { render, staticRenderFns } from "./GiftcardsDashboard.vue?vue&type=template&id=cc52f43a&scoped=true&"
import script from "./GiftcardsDashboard.vue?vue&type=script&lang=ts&"
export * from "./GiftcardsDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./GiftcardsDashboard.vue?vue&type=style&index=0&id=cc52f43a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc52f43a",
  null
  
)

export default component.exports